<template>
    <div class="card">
        <div class="card-header" id="headingOne">
            <h5 class="mb-0">
                <button v-b-toggle.patient-attributes class="btn btn-link" id="toggle-patient-query-button">
                    <arrow-right-drop-circle-outline :size="17" />
                    <span>
                        {{ this.$i18n.PATIENT_QUERY_TITLE }}
                        <span v-show="clauseCount > 0">({{ clauseCount }})</span>
                    </span>
                </button>
            </h5>
        </div>

        <b-collapse id="patient-attributes" accordion="patient-attributes-accordion" role="tabpanel">
            <div class="card-body">
                <div class="d-flex flex-column subQueryItemContainer">
                    <binarySubQueryItem
                        ref="gender"
                        class="subQueryItem"
                        category="Patient"
                        queryField="Patient.Gender"
                        queryName="Gender"
                        type="Gender"
                    />
                    <userEnabledDateSubquery
                        ref="yob"
                        class="subQueryItem"
                        category="Patient"
                        queryField="Patient.YearOfBirth"
                        queryName="Year of birth"
                        fieldType="Year"
                        defaultValFrom="1970"
                        :yearOnly="true"
                    />
                    <binarySubQueryItem
                        ref="deceased"
                        class="subQueryItem"
                        category="Patient"
                        type="YesOrNo"
                        queryField="Patient.IsDeceased"
                        queryName="Patient is deceased"
                    />
                    <binarySubQueryItem
                        ref="deathByDisease"
                        class="subQueryItem"
                        category="Patient"
                        type="YesOrNo"
                        queryField="Patient.DeathByDisease"
                        queryName="Death by disease"
                    />
                </div>
            </div>
        </b-collapse>
    </div>
</template>

<script>
import binarySubQueryItem from "./subquery-binary-item.vue";
import userEnabledDateSubquery from "./user-enabled-date.vue";
import { mapState } from "vuex";
import { BCollapse } from "bootstrap-vue";
import ArrowRightDropCircleOutline from "vue-material-design-icons/ArrowRightDropCircleOutline.vue";

export default {
    data() {
        return {};
    },
    components: {
        binarySubQueryItem,
        userEnabledDateSubquery,
        BCollapse,
        ArrowRightDropCircleOutline,
    },
    methods: {
        reboot() {
            for (var ref in this.$refs) this.$refs[ref].reboot();
        },
    },
    computed: {
        ...mapState({
            patientQuery: function (state) {
                return state.patientQuery;
            },
        }),
        clauseCount: function (state) {
            return Object.keys(this.patientQuery || {}).length;
        },
    },
};
</script>

<style scoped>
.binarySubQueryItem {
    height: 29px !important;
}

.userEnabledDateSubquery {
    height: 49px !important;
}

.subQueryHeader {
    background: #f2f7f8 !important;
}

.subQueryItemContainer {
    width: 80%;
}

.subQueryItem {
    background: white !important;
    margin-left: 15px;
}

.card {
    margin: 0;
    padding: 0;
}

.card-header {
    padding: 0rem;
}

.card-body {
    padding-top: 20px;
    padding-bottom: 20px;
}
</style>
